import { NgModule } from '@angular/core';
import { ChartCommonModule } from '@swimlane/ngx-charts';
import { HeatMapCellComponent } from './heat-map-cell.component';
import { HeatCellSeriesComponent } from './heat-map-cell-series.component';
import { HuddyHeatMapComponent } from './heat-map.component';

@NgModule({
  imports: [ChartCommonModule],
  declarations: [HeatMapCellComponent, HeatCellSeriesComponent, HuddyHeatMapComponent],
  exports: [HeatMapCellComponent, HeatCellSeriesComponent, HuddyHeatMapComponent]
})
export class HuddyHeatMapModule {}
